import React from 'react';

const FormItemPlanTypes = ({ item, onPlanTypeChange }) => {
  return (
    <div
    className="ml-6 flex flex-row border-t pt-2"
  >
    <label
      className={`${
        item.selectedOption
          ? "font-bold"
          : "font-light"
      } text-sm mr-2`}
    >
      Plan Type
    </label>
    <div
      className="flex flex-row"
    >
      {
        item.planTypes.map((planType) => (
          <label
            key={planType.id}
            className={`${
              planType.availableToOptions.includes(item.selectedOption?.id)
                ? "hover:cursor-pointer"
                : ""
            } flex items-center space-x-2`}
            title={planType.tooltip}
          >
            <input
              type="radio"
              name={`planType-${planType.id}`}
              value={planType.id}
              disabled={!planType.availableToOptions.includes(item.selectedOption?.id)}
              checked={item.selectedPlanType?.id === planType.id}
              onChange={() => onPlanTypeChange(item.id, planType.id)}
              className="form-radio"
            />
            <span
              className={`${
                item.selectedPlanType?.id === planType.id
                  ? "font-bold "
                  : "font-light "
              }${
                !planType.availableToOptions.includes(item.selectedOption?.id)
                ? "text-gray-300 "
                : ""
              }text-sm pr-4`}
            >
              {planType.label}
            </span>
          </label>
        ))
      }
    </div>
  </div>
);
};

export default FormItemPlanTypes;
